import { API_BASE_URL } from '../../lib/constants';
import { generateDownloadFilename } from '../../utils/fileUtils';
import { getLyricsText } from './LyricsRecordPreview';

export const isVideoRecord = (record) => {
  const url = typeof record?.videoUrl === 'string' ? record.videoUrl.trim() : '';
  return Boolean(url);
};

export const isAudioRecord = (record) => {
  const url = typeof record?.audioUrl === 'string' ? record.audioUrl.trim() : '';
  return Boolean(url);
};

export const isLyricsRecord = (record) => record?.type === 'LYRICS_GENERATION';

export const getMediaUrl = (record) => {
  if (isVideoRecord(record)) return record.videoUrl || '';
  if (isAudioRecord(record)) return record.audioUrl || '';
  return record.imageUrl || record.thumbnail || '';
};

export const getPreviewImageUrl = (record) => {
  if (isVideoRecord(record)) return record.imageUrl || '';
  if (isAudioRecord(record)) return record.coverUrl || record.imageUrl || '';
  return record.imageUrl || record.thumbnail || '';
};

export const getAbsoluteUrl = (url) => {
  if (!url) return '';
  return url.startsWith('http') ? url : `${API_BASE_URL}${url}`;
};

export const getStatusColor = (status = '') => {
  switch (status.toLowerCase()) {
    case 'completed':
      return 'success';
    case 'processing':
      return 'warning';
    case 'failed':
      return 'error';
    default:
      return 'default';
  }
};

export const canViewRecord = (record) => (
  isLyricsRecord(record) ? Boolean(getLyricsText(record)) : Boolean(getMediaUrl(record))
);

export const canDownloadRecord = (record) => (
  record.status === 'COMPLETED' && canViewRecord(record)
);

export const shareMediaType = (record) => {
  if (isLyricsRecord(record)) return 'text';
  if (isVideoRecord(record)) return 'video';
  if (isAudioRecord(record)) return 'audio';
  return 'image';
};

export const getTypeDisplayName = (type, t) => {
  const typeNames = {
    FACE_SWAP: t('creationRecord.types.faceSwap'),
    LOGO_GENERATION: t('creationRecord.types.logoGeneration'),
    ID_PHOTO_GENERATION: t('creationRecord.types.idPhotoGeneration'),
    PROFESSIONAL_PORTRAIT: t('creationRecord.types.professionalPortrait'),
    POP_ART_PORTRAIT: t('creationRecord.types.popArtPortrait'),
    ANIME_STYLE: t('creationRecord.types.animeStyle'),
    OIL_PAINTING: t('creationRecord.types.oilPainting'),
    WATERCOLOR: t('creationRecord.types.watercolor'),
    SKETCH_STYLE: t('creationRecord.types.sketchStyle'),
    CYBERPUNK: t('creationRecord.types.cyberpunk'),
    RESTORED_IMAGE: t('creationRecord.types.restoredImage'),
    TEXT_TO_IMAGE: t('creationRecord.types.TEXT_TO_IMAGE'),
    IMAGE_TO_IMAGE: t('creationRecord.types.IMAGE_TO_IMAGE'),
    TEXT_TO_VIDEO: t('creationRecord.types.TEXT_TO_VIDEO'),
    IMAGE_TO_VIDEO: t('creationRecord.types.IMAGE_TO_VIDEO'),
    REFERENCE_IMAGE_TO_VIDEO: t('creationRecord.types.REFERENCE_IMAGE_TO_VIDEO'),
    KEY_IMAGE_TO_VIDEO: t('creationRecord.types.KEY_IMAGE_TO_VIDEO'),
    TEXT_TO_AUDIO: t('creationRecord.types.TEXT_TO_AUDIO'),
    IMAGE_TO_AUDIO: t('creationRecord.types.IMAGE_TO_AUDIO'),
    LYRICS_GENERATION: t('creationRecord.types.LYRICS_GENERATION'),
  };
  return typeNames[type] || type;
};

export const toAudioPlayerMusic = (record) => ({
  id: record.id,
  title: record.prompt || record.type || 'Audio',
  audioUrl: getAbsoluteUrl(record.audioUrl || ''),
  lyrics: getLyricsText(record),
  lyricsTimestamp: record.lyricsTimestamp,
});

export function downloadText(text, filename) {
  const blob = new Blob([text || ''], { type: 'text/plain;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || 'lyrics.txt';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export function recordDownloadFilename(record) {
  return generateDownloadFilename(record.id);
}
